import { render, staticRenderFns } from "./editvideo.vue?vue&type=template&id=034450b4&scoped=true&"
import script from "./editvideo.vue?vue&type=script&lang=js&"
export * from "./editvideo.vue?vue&type=script&lang=js&"
import style0 from "./editvideo.vue?vue&type=style&index=0&id=034450b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034450b4",
  null
  
)

export default component.exports